"use strict";

exports.__esModule = true;
exports.PlantGridElementLayout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Device = require("../../Device");
var _reactRouterDom = require("react-router-dom");
var _Core = require("../../Core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* eslint-disable jsx-a11y/anchor-is-valid */

var STORAGE_CURRENT_PLANT_KEY = "vi-current-plant";

// The per-plant fetch returns every device record. The plant dashboards only
// ever see enabled devices (PlantInfoLoader), so the tiles must match.
var enabledDevices = function enabledDevices(devices) {
  return (devices || []).filter(function (device) {
    return device.enabled;
  });
};
var PlantGridElementLayout = exports.PlantGridElementLayout = function PlantGridElementLayout(props) {
  var _plantDevices$devices;
  var _useState = (0, _react.useState)({}),
    plantDevices = _useState[0],
    setPlantDevices = _useState[1];
  var deviceTags = _react["default"].useContext(_Device.DeviceTagListContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = props.devices,
    plant = props.plant,
    body = props.body;
  (0, _react.useEffect)(function () {
    setPlantDevices({
      plant: plant.name,
      devices: enabledDevices(devices)
    });
  }, [devices]);
  return /*#__PURE__*/_react["default"].createElement(_Device.DeviceListContext.Provider, {
    value: plantDevices == null ? void 0 : plantDevices.devices
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100%",
      fontSize: "2rem",
      backgroundColor: "#f2f4f6"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: "center"
    }
  }, plant.name), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "auto 10rem auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Device.MultiDeviceSelector, {
    minimal: true,
    devices: enabledDevices(devices),
    selectAllByDefault: true,
    selected: plantDevices == null || (_plantDevices$devices = plantDevices.devices) == null ? void 0 : _plantDevices$devices.map(function (device) {
      return device.uuid;
    }),
    tags: deviceTags ? deviceTags : [],
    onSelect: function onSelect(devices) {
      return setPlantDevices(Object.assign({}, plantDevices, {
        devices: devices
      }));
    },
    style: {
      minWidth: "10rem",
      maxWidth: "10rem",
      marginBottom: "5px"
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", null)), body, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: "absolute",
      width: "100%",
      textAlign: "center",
      fontSize: "1.5rem",
      bottom: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    style: {
      fontSize: "1rem"
    },
    "data-testid": "PlantGrid.ElementLayout.Link." + plant.name,
    to: "",
    onClick: function onClick() {
      localStorage.setItem(STORAGE_CURRENT_PLANT_KEY, plant.name);
      window.location.replace("/");
    }
  }, translate("PlantGrid.goToPlant", "Go to plant") + " " + plant.name)));
};